module.exports = __webpack_public_path__ + "static/media/anton.3fd55f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/anton.png
// module id = 1651
// module chunks = 0